<app-side-menu>
  <div class="purchase-orders-container">
    <!-- Filtros -->
    <div class="filters-section">
      <div class="filters-row">
        <div class="filter-group" style="flex: 2;">
          <label for="searchText" class="form-label">Busca:</label>
          <input
            type="text"
            id="searchText"
            class="form-control"
            [placeholder]="searchPlaceholder"
            (input)="onTableSearch($any($event.target).value)">
        </div>

        <div class="filter-actions" style="align-self: flex-end;">
          <button
            type="button"
            class="btn btn-outline-success"
            (click)="exportToCSV()"
            title="Exportar CSV">
            <i class="fas fa-file-csv me-2"></i>
            Exportar CSV
          </button>
        </div>
      </div>

      <div class="filters-row">
        <div class="filter-group">
          <label for="statusFilter" class="form-label">Filtrar por Status:</label>
          <div *ngIf="loadingStatuses" class="loading-statuses">
            <i class="fas fa-spinner fa-spin me-2"></i>
            Carregando status...
          </div>
          <select 
            *ngIf="!loadingStatuses"
            id="statusFilter" 
            class="form-select" 
            [(ngModel)]="filters.status"
            (change)="applyFilters()">
            <option value="">Todos os Status</option>
            <option *ngFor="let status of displayedStatusOptions" [value]="status.name">
              {{ status.name }}
            </option>
          </select>
        </div>

        <div class="filter-group">
          <label for="priorityFilter" class="form-label">Filtrar por Prioridade:</label>
          <select
            id="priorityFilter"
            class="form-select"
            [(ngModel)]="filters.priority"
            (change)="applyFilters()">
            <option value="">Todas as Prioridades</option>
            <option *ngFor="let option of priorityOptions" [value]="option.value">
              {{ option.label }}
            </option>
          </select>
        </div>

        <div class="filter-group">
          <label for="supplierFilter" class="form-label">Filtrar por Fornecedor:</label>
          <select 
            id="supplierFilter" 
            class="form-select" 
            [(ngModel)]="filters.supplierId"
            (change)="applyFilters()">
            <option value="">Todos os fornecedores</option>
            <option *ngFor="let supplier of suppliers" [value]="supplier.id">
              {{ supplier.companyName }}
            </option>
            <option *ngIf="suppliers.length === 0" disabled>Nenhum fornecedor encontrado</option>
          </select>
        </div>

        <div class="filter-group">
          <label for="requestedByFilter" class="form-label">Solicitado por:</label>
          <select 
            id="requestedByFilter" 
            class="form-select" 
            [(ngModel)]="filters.requestedByStaffId"
            (change)="applyFilters()">
            <option value="">Todos os funcionários</option>
            <option *ngFor="let staff of staffMembers" [value]="staff.Id">
              {{ staff.FullName }}
            </option>
          </select>
        </div>

        <div class="filter-group" *ngIf="!isSolicitacaoComprasFlow">
          <label for="costCenterFilter" class="form-label">Centro de Custo:</label>
          <select 
            id="costCenterFilter" 
            class="form-select" 
            [(ngModel)]="filters.costCenterId"
            (change)="applyFilters()">
            <option value="">Todos os centros de custo</option>
            <option *ngFor="let costCenter of costCenters" [value]="costCenter.id">
              {{ costCenter.name }}
            </option>
          </select>
        </div>
      </div>

      <!-- Segunda linha de filtros -->
      <div class="filters-row">
        <div class="filter-group">
          <label for="requestDateFrom" class="form-label">Data Solicitação (De):</label>
          <input 
            type="date" 
            id="requestDateFrom" 
            class="form-control" 
            [(ngModel)]="filters.requestDateFrom"
            (change)="applyFilters()">
        </div>

        <div class="filter-group">
          <label for="requestDateTo" class="form-label">Data Solicitação (Até):</label>
          <input 
            type="date" 
            id="requestDateTo" 
            class="form-control" 
            [(ngModel)]="filters.requestDateTo"
            (change)="applyFilters()">
        </div>

        <div class="filter-group" *ngIf="!isSolicitacaoComprasFlow">
          <label for="expectedDeliveryFrom" class="form-label">Entrega Esperada (De):</label>
          <input 
            type="date" 
            id="expectedDeliveryFrom" 
            class="form-control" 
            [(ngModel)]="filters.expectedDeliveryFrom"
            (change)="applyFilters()">
        </div>

        <div class="filter-group" *ngIf="!isSolicitacaoComprasFlow">
          <label for="expectedDeliveryTo" class="form-label">Entrega Esperada (Até):</label>
          <input 
            type="date" 
            id="expectedDeliveryTo" 
            class="form-control" 
            [(ngModel)]="filters.expectedDeliveryTo"
            (change)="applyFilters()">
        </div>
      </div>

      <!-- Terceira linha de filtros -->
      <div class="filters-row">
        <div class="filter-group" *ngIf="!isSolicitacaoComprasFlow">
          <label for="totalAmountFrom" class="form-label">Valor Mínimo:</label>
          <input 
            type="number" 
            id="totalAmountFrom" 
            class="form-control" 
            step="0.01"
            min="0"
            [(ngModel)]="filters.totalAmountFrom"
            (change)="applyFilters()"
            placeholder="0.00">
        </div>

        <div class="filter-group" *ngIf="!isSolicitacaoComprasFlow">
          <label for="totalAmountTo" class="form-label">Valor Máximo:</label>
          <input 
            type="number" 
            id="totalAmountTo" 
            class="form-control" 
            step="0.01"
            min="0"
            [(ngModel)]="filters.totalAmountTo"
            (change)="applyFilters()"
            placeholder="0.00">
        </div>

        <div class="filter-group">
          <label for="requiresApprovalFilter" class="form-label">Requer Aprovação:</label>
          <select 
            id="requiresApprovalFilter" 
            class="form-select" 
            [(ngModel)]="filters.requiresApproval"
            (change)="applyFilters()">
            <option value="">Todos</option>
            <option value="true">Sim</option>
            <option value="false">Não</option>
          </select>
        </div>

        <div class="filter-actions">
          <button 
            type="button" 
            class="btn btn-outline-secondary"
            (click)="clearFilters()">
            <i class="fas fa-times me-2"></i>
            Limpar Filtros
          </button>
        </div>
      </div>
    </div>

    <!-- Error Message (fora do card) -->
    <div *ngIf="error" class="alert alert-danger mb-3" role="alert">
      <div class="d-flex justify-content-between align-items-center">
        <div>
          <i class="fas fa-exclamation-triangle me-2"></i>
          {{ error }}
        </div>
        <button 
          type="button" 
          class="btn btn-outline-danger btn-sm"
          (click)="retryLoad()">
          <i class="fas fa-redo me-1"></i>
          Tentar Novamente
        </button>
      </div>
    </div>

    <!-- Conteúdo em Card com overlay de loading (igual ao Customers) -->
    <div class="purchase-orders-card">
<!-- Tabela de Pedidos de Compra -->
      <div *ngIf="!error && !isLoading && filteredPurchaseOrders.length > 0">
        <app-table
          [title]="tableTitle"
          [columns]="displayColumns"
          [data]="filteredPurchaseOrders"
          [loading]="isLoading"
          [showSearch]="showSearch"
          [clickable]="clickable"
          [actions]="tableActions"
          [disablePagination]="false"
          [itemsPerPage]="pageSize"
          [currentPageFromBackend]="currentPage"
          [totalItemsFromBackend]="totalItems"
          [hasNextPageFromBackend]="hasNextPage"
          [hasPreviousPageFromBackend]="hasPreviousPage"
          [enableSorting]="true"
          (rowClick)="viewOrder($event?.id ?? $event?.Id)"
          (actionClick)="onActionClick($event)"
          (pageChange)="onPageChange($event)"
          (pageSizeChange)="onPageSizeChange($event)"
          (sortChange)="onSortChange($event)">
          <app-button
            *appHasPermission="'PurchaseOrders.Create'"
            table-header-action
            [text]="newOrderButtonText"
            [color]="'var(--primary-light)'"
            [height]="'42px'"
            className="new-po-btn"
            (buttonClick)="createNewOrder()">
          </app-button>
        </app-table>
      </div>

      <!-- Estado Vazio Simples -->
      <div *ngIf="!error && !isLoading && filteredPurchaseOrders.length === 0" class="empty-state-simple">
        <div class="empty-message">
          <i class="fas fa-shopping-cart"></i>
          <p *ngIf="hasActiveFilters()">{{ emptyStateFilteredMessage }}</p>
          <p *ngIf="!hasActiveFilters()">{{ emptyStateNoDataMessage }}</p>
          <button
            *appHasPermission="'PurchaseOrders.Create'"
            type="button"
            class="btn btn-primary mt-3"
            (click)="createNewOrder()">
            <i class="fas fa-plus me-2"></i>
            {{ emptyStateCreateLabel }}
          </button>
        </div>
      </div>
    </div>

    <app-modal
      *ngIf="!isSolicitacaoComprasFlow"
      [isOpen]="showApproveModal"
      [title]="approveModalTitle"
      [size]="'md'"
      [closable]="true"
      (close)="closeApproveModal()">
      <div class="report-form">
        <p class="mb-3">
          Confirma a aprovação do pedido
          <strong>{{ selectedOrderForApprove?.orderNumber }}</strong>?
        </p>
        <div class="mb-3">
          <label class="form-label">Comentários da Aprovação (opcional)</label>
          <textarea
            class="form-control"
            rows="3"
            [(ngModel)]="approveComments"
            placeholder="Adicione observações da aprovação..."></textarea>
        </div>
      </div>
      <div slot="footer" class="modal-footer-buttons">
        <button type="button" class="btn btn-secondary" (click)="closeApproveModal()">Voltar</button>
        <button *appHasPermission="'PurchaseOrders.Approve'" type="button" class="btn btn-success" (click)="confirmApproveOrder()">
          <i class="fas fa-circle-check me-2"></i>
          Aprovar Pedido
        </button>
      </div>
    </app-modal>

    <app-modal
      [isOpen]="showCancelModal"
      [title]="'Recusar / Cancelar Pedido'"
      [size]="'md'"
      [closable]="true"
      (close)="closeCancelModal()">
      <div class="report-form">
        <p class="mb-3">
          Informe o motivo para recusar/cancelar o pedido
          <strong>{{ selectedOrderForCancel?.orderNumber }}</strong>.
        </p>
        <div class="mb-3">
          <label class="form-label">Motivo do Cancelamento *</label>
          <textarea
            class="form-control"
            rows="4"
            [(ngModel)]="cancelReason"
            placeholder="Descreva o motivo da recusa/cancelamento..."></textarea>
        </div>
      </div>
      <div slot="footer" class="modal-footer-buttons">
        <button type="button" class="btn btn-secondary" (click)="closeCancelModal()">Voltar</button>
        <button type="button" class="btn btn-danger" (click)="confirmCancelOrder()">
          <i class="fas fa-ban me-2"></i>
          Confirmar Cancelamento
        </button>
      </div>
    </app-modal>
  </div>
</app-side-menu>
